import React, { FC } from 'react';
import { DocumentsType } from 'v2-types/order';

import { useManualDocumentUploadModal } from './manual-document-update-modal-hooks';
import { ManualDocumentUploadModalScene } from './manual-document-update-modal-scene';

type ManualDocumentUploadModalProps = {
  open: boolean;
  document: DocumentsType,
  handleClose: () => void,
  onUpdateScuccess: () => void,
};
export const ManualDocumentUploadModal: FC<ManualDocumentUploadModalProps> = ({
  open,
  document,
  handleClose,
  onUpdateScuccess
}) => {
  const {
    t,
    control,
    watch,
    isValid,
    onUploadDocuments,
    openFileDialog,
    onRemoveFile,
    getRootProps,
    getInputProps,
    filesToUpload,
    isLoading,
    setSelectedParty,
    selectedParty,
    setValue
  } = useManualDocumentUploadModal({
    document,
    onUpdateScuccess
  });
  const onPartySelect = ({ partyId }) => {
    setSelectedParty(partyId);
  };

  return (
    <ManualDocumentUploadModalScene
      open={open}
      t={t}
      handleClose={handleClose}
      control={control}
      watch={watch}
      isValid={isValid}
      onPartySelect={onPartySelect}
      onUploadDocuments={onUploadDocuments}
      openFileDialog={openFileDialog}
      getRootProps={getRootProps}
      getInputProps={getInputProps}
      filesToUpload={filesToUpload}
      onRemoveFile={onRemoveFile}
      isLoading={isLoading}
      document={document}
      selectedParty={selectedParty}
      setValue={setValue}
    />
  );
};
